import transferSyntaxes from './transferSyntaxes';

export { transferSyntaxes };
